const countries = [ 
{ "gentilico" : "norte-americana",
"nome_pais" : "América do Norte",
"nome_pais_int" : "North America",
"sigla" : "North America"
},
{ "gentilico" : "europeia",
"nome_pais" : "Europa Ampliada",
"nome_pais_int" : "Enlarged Europe",
"sigla" : "Enlarged Europe"
},
{ "gentilico" : "sul-americana",
"nome_pais" : "América do Sul",
"nome_pais_int" : "South America",
"sigla" : "South America"
},
{ "gentilico" : "médio-oriental e africana",
"nome_pais" : "Oriente Médio e África",
"nome_pais_int" : "Middle East and Africa",
"sigla" : "Middle East and Africa"
},
{ "gentilico" : "asiática",
"nome_pais" : "Índia e Ásia-Pacífico",
"nome_pais_int" : "India and Asia Pacific",
"sigla" : "India and Asia Pacific"
},
{ "gentilico" : "chinesa",
"nome_pais" : "China",
"nome_pais_int" : "China",
"sigla" : "China"
}
];
export default countries;
